import { createTheme } from '@mui/material/styles';

// Create a theme instance with custom typography
const theme = createTheme({
  typography: {
    fontFamily: [
      'Inter'
    ].join(','),
    h1: {
      fontFamily: 'Inter',
    },
    h2: {
      fontFamily: 'Inter',
    },
    h3: {
      fontFamily: 'Inter',
    },
    h4: {
      fontFamily: 'Inter',
    },
    h5: {
      fontFamily: 'Inter',
    },
    h6: {
      fontFamily: 'Inter',
    },
    subtitle1: {
      fontFamily: 'Inter',
    },
    subtitle2: {
      fontFamily: 'Inter',
    },
    body1: {
      fontFamily: 'Inter',
    },
    body2: {
      fontFamily: 'Inter',
    },
    button: {
      fontFamily: 'Inter',
      textTransform: 'none',
    },
    caption: {
      fontFamily: 'Inter',
    },
    overline: {
      fontFamily: 'Inter',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Fredoka';
          font-style: normal;
          font-weight: 400;
        }
      `,
    },
  },
});

export default theme; 